import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/t_logo.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row d-flex justify-content-center mt-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_0,
    class: "mt-2 text-center",
    style: {"max-width":"300px"}
  })
], -1)
const _hoisted_3 = { class: "row bg-dange text-center justify-content-center" }
const _hoisted_4 = { class: "fs-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-primary mt-5 d-flex align-self-center flex-column text-center"
}
const _hoisted_6 = {
  key: 1,
  class: "card card-body shadow"
}
const _hoisted_7 = { class: "row mb-sm-2" }
const _hoisted_8 = { class: "col-form-label col-sm-4" }
const _hoisted_9 = {
  key: 0,
  class: "badge bg-danger me-2"
}
const _hoisted_10 = { class: "col-sm-8" }
const _hoisted_11 = ["readonly"]
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_14 = { class: "offset-sm-4 ps-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "メール受信許可設定のお願い", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "携帯会社（通信回線事業者）のメールをご利用の方は下記ドメインからのメール受信許可の設定をお願いいたします。", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "fs-3" }
const _hoisted_20 = { class: "mt-4 offset-sm-4 ps-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "設定方法については下記の携帯会社サイトをご参照ください。", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 1,
  class: "row mb-sm-2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, "新しいパスワード", -1)
const _hoisted_29 = { class: "col-sm-8" }
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = ["readonly", "type"]
const _hoisted_32 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_33 = { class: "badge bg-primary" }
const _hoisted_34 = {
  key: 2,
  class: "mt-3 mb-3"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "offset-sm-4 ps-2" }, [
  /*#__PURE__*/_createTextVNode(" 8～32文字で入力してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 英文字(大文字、小文字)、数字、記号の2種類以上で作成してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※使用可能な記号  ! # $ % & / = ? @ ")
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 3,
  class: "row mb-sm-2"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, "パスワード（確認用）", -1)
const _hoisted_39 = { class: "col-sm-8" }
const _hoisted_40 = { class: "input-group" }
const _hoisted_41 = ["readonly", "type"]
const _hoisted_42 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_43 = { class: "badge bg-primary" }
const _hoisted_44 = { class: "row mb-sm-2" }
const _hoisted_45 = { class: "col-form-label col-sm-4" }
const _hoisted_46 = {
  key: 0,
  class: "badge bg-danger me-2"
}
const _hoisted_47 = { class: "col-sm-8" }
const _hoisted_48 = ["readonly"]
const _hoisted_49 = {
  key: 4,
  class: "mt-3 mb-3"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "offset-sm-4 ps-2" }, " 本人確認のためログインIDのメールアドレスに「日本歯科衛生協会 設定確認について」という件名で確認メールが送られます。 ", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 5,
  class: "row mb-sm-2"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
  /*#__PURE__*/_createTextVNode("確認コード")
], -1)
const _hoisted_54 = { class: "col-sm-8" }
const _hoisted_55 = {
  key: 2,
  class: "row mt-3 row"
}
const _hoisted_56 = { class: "col-sm-8 offset-sm-4 ps-4 pe-4" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "d-flex flex-row input-group" }
const _hoisted_59 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, "お名前：" + _toDisplayString(_ctx.userInfo?.userName), 1)
    ]),
    (_ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 設定変更しました。 "))
      : _createCommentVNode("", true),
    (!_ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              (!_ctx.confirming)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "必須"))
                : _createCommentVNode("", true),
              _createTextVNode("ログインID （メールアドレス）")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: _ctx.confirming,
                onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginIdOperation && _ctx.loginIdOperation(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kaiinJoho.webKaiinLoginId) = $event)),
                class: "form-control form-control-lg",
                maxlength: "100",
                style: _normalizeStyle({'background-color': _ctx.loginIdValid ? '' : 'lightpink'})
              }, null, 44, _hoisted_11), [
                [_vModelText, _ctx.kaiinJoho.webKaiinLoginId]
              ]),
              (_ctx.maiAddressMessage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.maiAddressMessage), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.configs['mail_domain']), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_docomo'],
                        target: "_blank"
                      }, "NTTドコモ 受信リスト／拒否リスト設定", 8, _hoisted_23)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_au'],
                        target: "_blank"
                      }, "au(KDDI) 受信リスト設定", 8, _hoisted_24)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_softbank'],
                        target: "_blank"
                      }, "ソフトバンク 受信許可リスト設定", 8, _hoisted_25)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_rakuten'],
                        target: "_blank"
                      }, "楽天モバイル 受信リスト／拒否リストの設定・変更・削除（楽メール）", 8, _hoisted_26)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.confirming || !!_ctx.password)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      readonly: _ctx.confirming,
                      type: _ctx.showPassword ? 'type' :'password',
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                      class: "form-control form-control-lg",
                      style: _normalizeStyle({'background-color': !_ctx.password ? '' : (_ctx.validPassword ? 'aquamarine' : 'lightpink')}),
                      maxlength: "32",
                      placeholder: "※パスワード変更する時は入力してください。"
                    }, null, 12, _hoisted_31), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-lg border-start-0 bg-white",
                      style: {"border-color":"lightgray"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                      ]),
                      _createVNode(_component_fa, {
                        class: "me-1 text-primary",
                        icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                      }, null, 8, ["icon"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
            : _createCommentVNode("", true),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      readonly: _ctx.confirming,
                      onPaste: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                      type: _ctx.showPassword ? 'type' :'password',
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                      class: "form-control form-control-lg",
                      style: _normalizeStyle({'background-color': !_ctx.confirmPassword ? '' : ((_ctx.password===_ctx.confirmPassword) ? 'aquamarine' : 'lightpink')}),
                      maxlength: "32",
                      placeholder: "※パスワード変更する時は入力してください。"
                    }, null, 44, _hoisted_41), [
                      [_vModelDynamic, _ctx.confirmPassword]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-lg border-start-0 bg-white",
                      style: {"border-color":"lightgray"},
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                      ]),
                      _createVNode(_component_fa, {
                        class: "me-1 text-primary",
                        icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                      }, null, 8, ["icon"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("label", _hoisted_45, [
              (!_ctx.confirming)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, "必須"))
                : _createCommentVNode("", true),
              _createTextVNode("氏名")
            ]),
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: _ctx.confirming,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.kaiinJoho.webKaiinName) = $event)),
                class: "form-control form-control-lg",
                maxlength: "32",
                style: _normalizeStyle({'background-color': _ctx.kaiinJoho.webKaiinName ? '' : 'lightpink'})
              }, null, 12, _hoisted_48), [
                [_vModelText, _ctx.kaiinJoho.webKaiinName]
              ])
            ])
          ]),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
            : _createCommentVNode("", true),
          (_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmCode) = $event)),
                    class: "form-control form-control-lg",
                    maxlength: "6",
                    style: _normalizeStyle({'background-color': _ctx.validConfirmCode || !_ctx.confirmCode ? '' : 'lightpink'}),
                    placeholder: "※メールに記載されている確認コードを入力してください。"
                  }, null, 4), [
                    [_vModelText, _ctx.confirmCode]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            (!_ctx.confirming)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-lg btn-primary text-white w-100",
                  disabled: !_ctx.canConfirm,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirm()))
                }, [
                  _createVNode(_component_fa, {
                    class: "me-1",
                    icon: "check"
                  }),
                  _createTextVNode("確認する")
                ], 8, _hoisted_57))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_58, [
              (_ctx.confirming)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-lg btn-lightgray text-white w-25",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.backFromConfirm()))
                  }, [
                    _createVNode(_component_fa, {
                      class: "me-1",
                      icon: "arrow-left"
                    }),
                    _createTextVNode("戻る")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.confirming)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-lg btn-primary text-white w-75",
                    disabled: !_ctx.validConfirmCode,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateSettings()))
                  }, [
                    _createVNode(_component_fa, {
                      class: "me-1",
                      icon: "save"
                    }),
                    _createTextVNode("変更する")
                  ], 8, _hoisted_59))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}